import { Theme } from "./../styles";
import { TextAndBoxStyleConfig } from "./../types/global";

export const getTextStyle = (config: TextAndBoxStyleConfig, theme: Theme) => {
  const { isCurrent, isBusinessDay, isHoliday, variant } = config;
  if (isCurrent) return variant === "bottomRow" ? theme.colors.placeholder : theme.colors.accent;
  if (isHoliday)
    return variant === "bottomRow" ? '#212121' : theme.colors.textPrimary;
  if (isBusinessDay)
    return variant === "bottomRow" ? '#212121' : theme.colors.textPrimary;

  return '#212121';
};
